import {Component, computed, ViewEncapsulation} from '@angular/core';

import {Message} from '../../models/message.interface';
import {isRunInProgress} from '../../models/run';
import {AiChatService} from '../../services/ai-chat.service';

@Component({
  selector: 'ai-chat-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ErrorComponent {
  readonly isRunInProgress = computed(() => {
    const status = this.aiChatService.status();

    return isRunInProgress(status);
  });
  error = computed<Message>(() => {
    const value = this.aiChatService.chatError();

    if (value) {
      return {
        sentBy: 'assistant',
        content: [{value, type: 'error'}]
      };
    }

    return null;
  });

  constructor(private aiChatService: AiChatService) {}

  regenerateConversation() {
    this.aiChatService.regenerateChat();
  }
}
